import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.tabelaprecobackup.cadastra(payload).then(res => {
        dispatch('ActionSetTabelaPreco',res)
    }).catch(err => {
        dispatch('ActionSetTabelaPreco',err)
    })
}


export const ActionSetTabelaPreco = ({commit},payload) =>{
    commit(types.SET_TABELAPRECO,payload)
}


